function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    id: "Layer_1",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180.5 25",
    style: {
      "enableBackground": "new 0 0 180.5 25"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-384.188 108)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(384.188 -108)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#1DECEF"
    },
    d: "M2.1,25c-0.6,0-1.1-0.2-1.5-0.7c-0.8-0.9-0.8-2.2,0-3.1L21.1,0.6c0.9-0.8,2.2-0.8,3.1,0 c0.8,0.9,0.8,2.2,0,3.1L3.7,24.3C3.3,24.7,2.7,25,2.1,25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#1DECEF"
    },
    d: "M16.7,25c-0.6,0-1.1-0.2-1.5-0.7c-0.8-0.9-0.8-2.2,0-3.1L35.8,0.6c0.7-0.5,1.6-0.7,2.4-0.5 c0.8,0.3,1.3,1.1,1.4,1.9v20.6c0,1.2-0.9,2.2-2.1,2.2c-1.2,0-2.2-0.9-2.2-2.1c0,0,0-0.1,0-0.1V7.4L18.3,24.4 C17.8,24.8,17.3,25,16.7,25z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(434.32 -102.318)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M14,14h-3.2V5.9l-3.6,5.9H6.8L3.2,5.9V14H0V0h3.2L7,6.2L10.7,0H14L14,14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M21.3,11.6c0.7,0,1.4-0.3,2-0.8l2.4,1.3c-1,1.4-2.7,2.2-4.4,2.1c-3.4,0-5.5-2.3-5.5-5.2 c-0.1-2.8,2.1-5.1,5-5.2c0.1,0,0.3,0,0.4,0c2.8,0,5,2.2,5,5c0,0.1,0,0.2,0,0.2c0,0.4,0,0.8-0.2,1.1h-7 C19.3,11.1,20.3,11.7,21.3,11.6z M23.2,8c-0.2-1-1.1-1.7-2.1-1.6c-1-0.1-2,0.6-2.1,1.6c0,0,0,0,0,0L23.2,8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M33.8,3.9v3.4c-1.3-0.3-2.9,0.2-2.9,2.1V14H28V4.1h2.9v1.8C31.3,4.6,32.5,3.8,33.8,3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M34.5,9c0-2.9,2.3-5.2,5.2-5.2c1.9,0,3.6,1,4.5,2.6l-2.6,1.5c-0.4-0.7-1.1-1.2-1.9-1.1 c-1.3,0-2.3,1-2.3,2.3s1,2.3,2.3,2.3c0.8,0,1.6-0.4,1.9-1.1l2.6,1.5c-1.4,2.5-4.6,3.4-7.1,1.9C35.4,12.6,34.5,10.8,34.5,9L34.5,9z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M54.9,7.8V14H52V8.3c0.1-0.9-0.5-1.7-1.4-1.8c-0.1,0-0.2,0-0.4,0c-1.1,0-1.8,0.7-1.8,2.1V14h-2.9V0 h2.9v4.9c0.6-0.9,1.7-1.3,2.8-1.1c2.1,0,3.8,1.7,3.8,3.8C54.9,7.6,54.9,7.7,54.9,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M67.1,4.1V14h-2.9v-1c-0.7,0.8-1.8,1.2-2.9,1.1c-2.7-0.1-4.8-2.4-4.7-5.2c0,0,0,0,0,0 c-0.1-2.7,1.9-5.1,4.7-5.2c0,0,0,0,0,0c1.1,0,2.1,0.4,2.9,1.1V4.1H67.1z M64.2,9c0.1-1.3-0.9-2.4-2.2-2.4c-0.1,0-0.2,0-0.3,0 c-1.3,0-2.4,1-2.4,2.4c0,0,0,0.1,0,0.1c-0.1,1.3,0.9,2.4,2.2,2.4c0.1,0,0.2,0,0.3,0c1.2,0.1,2.3-0.8,2.4-2 C64.2,9.3,64.2,9.1,64.2,9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M78.8,7.8V14h-2.9V8.3c0.1-0.9-0.5-1.7-1.4-1.8c-0.1,0-0.2,0-0.4,0c-1.1,0-1.8,0.7-1.8,2.1V14h-2.9 V4.1h2.9v1C73,4.2,74,3.8,75.1,3.9C77.2,3.8,78.8,5.2,78.8,7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M84.7,6.9v3.6c0,0.8,0.8,1,2.1,0.8V14c-3.9,0.3-5-0.8-5-3.6V6.9h-1.6V4.1h1.6v-2l2.9-1v2.9h2.1V7 h-2.1V6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M96.9,10.9V14h-8.1V0H92v10.9H96.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M108.2,4.1V14h-2.9v-1c-0.7,0.8-1.8,1.2-2.9,1.1c-2.7-0.1-4.8-2.4-4.7-5.2c0,0,0,0,0,0 c-0.2-2.7,1.9-5.1,4.7-5.2c0,0,0,0,0,0c1.1,0,2.1,0.4,2.9,1.1V4.1H108.2z M105.3,9c0.1-1.3-0.9-2.4-2.2-2.4c-0.1,0-0.2,0-0.3,0 c-1.3,0-2.4,1-2.4,2.4c0,0,0,0.1,0,0.1c-0.1,1.3,0.9,2.4,2.2,2.4c0.1,0,0.2,0,0.3,0c1.2,0.1,2.3-0.8,2.4-2 C105.3,9.3,105.3,9.1,105.3,9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M121.2,9c0.1,2.7-1.9,5.1-4.7,5.2c0,0,0,0,0,0c-1.1,0-2.1-0.4-2.9-1.1v1h-3.1V0h2.9v4.9 c0.7-0.8,1.8-1.2,2.9-1.1C119.1,3.9,121.3,6.2,121.2,9z M118.1,9c0.1-1.3-0.9-2.4-2.2-2.4c-0.1,0-0.2,0-0.3,0 c-1.3,0-2.4,1-2.4,2.4c0,0,0,0.1,0,0.1c-0.1,1.3,0.9,2.4,2.2,2.4c0.1,0,0.2,0,0.3,0c1.2,0.1,2.3-0.8,2.4-2 C118.2,9.3,118.2,9.1,118.1,9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      "fill": "#FFFFFF"
    },
    d: "M130.3,11.1c0,2.3-1.9,3.3-4.1,3.3c-1.8,0.2-3.5-0.8-4.2-2.4l2.6-1.5c0.2,0.7,0.9,1.2,1.6,1.1 c0.7,0,1.1-0.2,1.1-0.7c0-1.1-4.9-0.5-4.9-3.9c0-2.1,1.8-3.3,3.9-3.3c1.6-0.1,3.1,0.7,3.9,2.1l-2.6,1.3c-0.2-0.5-0.7-0.8-1.3-0.8 c-0.5,0-0.8,0.2-0.8,0.5C125.5,8.2,130.3,7.3,130.3,11.1z"
  }))));
};

export default __webpack_public_path__ + "static/media/nav-logo.84161100.svg";
export { SvgComponent as ReactComponent };